import {
  API_BASE_URL,
  // URL_UPLOAD_ARCHIVE
} from './DefaultUri';

export const callApi = (_endpoint, _request) => {
  return fetch(API_BASE_URL.concat(_endpoint), _request)
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then((json) => {
          if (!response.ok) {
            return Promise.reject(json);
          }
          return json;
        });
      }
      if (response.ok) {
        return response
          .text()
          .then((text) => {
            try {
              const json = JSON.parse(text);
              if (json) {
                return json;
              }
            } catch (e) {
              // console.log(e);
            }
            return { responseText: text };
          })
          .catch((e) => {
            return { error: e };
          });
      }
      throw new Error(`${response.status} - ${response.statusText}`);
    })
    .catch((e) => {
      throw e;
    });
};

export const callApiUrl = (_endpoint, _request) => {
  return fetch(_endpoint, _request).then((response) => {
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return response.json().then((json) => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        return json;
      });
    }
    if (response.ok) {
      return response.text().then((text) => {
        const json = JSON.parse(text);
        if (json) {
          return json;
        }
        return { responseText: text };
      });
    }
    throw new Error(`${response.status} - ${response.statusText}`);
  });
};

/* export const downloadAsync = (
  nombreArchivo,
  query,
  token,
  uri,
  target = false
) => {
  return fetch(API_BASE_URL.concat(uri, '?token=', token, query)).then(
    (response) => {
      if (response.status === 200) {
        return response.blob().then((blob) => {
          if (blob.type !== 'application/json') {
            if (blob.type !== 'text/html') {
              if (target) {
                const file = new Blob([blob], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
              } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = nombreArchivo;
                a.click();
              }
              return blob;
            }
          }
          throw new Error('Error al Descargar');
        });
      }
      throw new Error('Error al Descargar');
    }
  );
};
*/
export const withloadAsync = (query, token, uri) =>
  callApi(uri.concat('?token=', token, query), {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

export const withPostPutDeleteAsync = (data, method, token, uri) =>
  callApi(uri.concat('?&token=', token), {
    method,
    body: JSON.stringify(data),
  });

/* export const withUploadAsync = (formdata, token, URI = URL_UPLOAD_ARCHIVE) =>
  callApi(URI.concat('?token=', token), {
    method: 'POST',
    body: formdata,
  }); */

export const getFormImage = (archivo, id, tabla, nombre) => {
  const formData = new FormData();
  formData.append('archivo', archivo, nombre);
  formData.append('id', id);
  formData.append('tabla', tabla);
  return formData;
};
